import React from 'react';
import Text from './base';

const Small = props => <Text defaultTag="small" variant="small" {...props} />;

export default Small;
